import React from 'react';

// "Needs attention" then "What's working": every open issue, then every passing check.
// Stacked rows rather than side by side, issues first — they are what the reader acts on.
//
// Shared by the single-page report and the slide deck. A scan that finds nothing wrong
// still ran a dozen checks, and listing them is what makes a clean report read as a result
// rather than as an empty page.

const sevPill = (severity) => (
  <span className={`deck-pill sev-${severity || 'info'}`}>{(severity || 'info').toUpperCase()}</span>
);

function StrengthsGaps({ strengths, gaps, revealClass = '' }) {
  const r = (d) => (revealClass ? `${revealClass} d${d}` : '');
  return (
    <div className="deck-sg-grid">
      <div className={`deck-panel deck-sg-panel deck-sg-gap ${r(1)}`}>
        <div className="deck-panel-label">⚠ Needs attention · {gaps.length}</div>
        {gaps.length === 0 ? (
          <p className="deck-sg-empty">Nothing needs attention — every check came back clean.</p>
        ) : (
          <ul className="deck-sg-list">
            {gaps.map((f, i) => (
              <li key={i} className="deck-sg-item">
                {sevPill(f.severity)}
                <div>
                  <div className="deck-sg-title">{f.title}</div>
                  {f.description && <div className="deck-sg-desc">{f.description}</div>}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
      <div className={`deck-panel deck-sg-panel deck-sg-pass ${r(2)}`}>
        <div className="deck-panel-label">✓ What's working · {strengths.length}</div>
        {strengths.length === 0 ? (
          <p className="deck-sg-empty">No checks passed yet — every item above is an opportunity.</p>
        ) : (
          <ul className="deck-sg-list">
            {strengths.map((f, i) => (
              <li key={i} className="deck-sg-item">
                <span className="deck-sg-icon" aria-hidden="true">✓</span>
                <div>
                  <div className="deck-sg-title">{f.title}</div>
                  {f.description && <div className="deck-sg-desc">{f.description}</div>}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default StrengthsGaps;
